window.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('#lumin-sticky-atc');
  const mainButton = document.querySelector('.product__info-container input.product-form__submit[type="submit"]');

  if (!stickyCart || !mainButton) return;

  const variantSelect = stickyCart.querySelector('select[name="id"]');
  const stickyImages = stickyCart.querySelectorAll('.product-content img');
  const stickyPrice = stickyCart.querySelector('.sticky-product-price');
  const mainVariantInput = Array.from(document.querySelectorAll('.product-form [name="id"]')).find(
    (input) => !input.closest('#lumin-sticky-atc')
  );

  const setVisible = (visible) => {
    stickyCart.classList.toggle('show', visible);
    stickyCart.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.documentElement.style.paddingBottom = visible ? stickyCart.clientHeight + 'px' : '0';
    document.documentElement.style.height = 'auto';
  };

  const syncSelection = () => {
    const selectedOption = variantSelect?.selectedOptions[0];

    if (!selectedOption) return;

    if (selectedOption.dataset.img) {
      stickyImages.forEach((image) => {
        image.src = selectedOption.dataset.img;
      });
    }

    if (stickyPrice && selectedOption.dataset.price) {
      stickyPrice.textContent = selectedOption.dataset.price;
    }
  };

  let framePending = false;

  const updateVisibility = () => {
    setVisible(mainButton.getBoundingClientRect().bottom < 0);
    framePending = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (framePending) return;

      framePending = true;
      window.requestAnimationFrame(updateVisibility);
    },
    { passive: true }
  );
  window.addEventListener('resize', updateVisibility, { passive: true });
  variantSelect?.addEventListener('change', syncSelection);
  mainVariantInput?.addEventListener('change', (event) => {
    if (!variantSelect || !event.target.value) return;

    variantSelect.value = event.target.value;
    syncSelection();
  });

  syncSelection();
  updateVisibility();
});